import { useLocation } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import * as s from "./SideNavBarStyled";
import * as mediaQuery from "components/MediaQuery";
import { menuClasses, Menu, MenuItemStyles } from "react-pro-sidebar";
import { calcRem } from "styles/theme";
import { COLORS } from "styles/colors";
import { Tooltip } from "antd";
import MenuItemComponent from "./MenuItem";
import { useMenu } from "hook/useMenu";
import { useMemo } from "react";
import * as MediaQuery from "components/MediaQuery";

interface SideBarProps {}

const themes = {
  light: {
    menu: {
      hover: {
        color: "#44596e",
      },
      disabled: {
        color: "#9fb6cf",
      },
    },
  },
  dark: {
    menu: {
      // menuContent: "#082440",
      // icon: COLORS.COMPANY,
      hover: {
        color: COLORS.WHITE,
      },
      disabled: {
        color: `${COLORS.WHITE}20`,
      },
    },
  },
};

function MenuComponent(props: SideBarProps): JSX.Element {
  const location: any = useLocation();

  const theme = useAppSelector((state) => state.theme.theme);
  const { lists } = useMenu({});
  const isMobile = MediaQuery.useIsMobile();

  const menuItemStyles: MenuItemStyles = {
    root: {
      fontSize: calcRem(14),
      height: isMobile ? 50 : 58,
      color: COLORS.SIDEBARMENU,

      "&:hover": {
        backgroundColor: "transparent",
      },
      ".ps-menu-label": {
        fontWeight: 500,
      },
      "> a.ps-menu-button": isMobile
        ? {
            paddingLeft: 0,
            paddingRight: 0,
          }
        : undefined,
    },
    icon: {
      svg: {
        width: "24px",
        "&.maintenance-icon": {
          width: "26px",
          height: "22px",
          path: {
            stroke: "currentColor !important",
          },
        },
      },
    },
    button: {
      [`&.${menuClasses.disabled}`]: {
        color: themes[theme].menu.disabled.color,
      },
      ".ps-active": {
        color: `${COLORS.COMPANY} !important`,
      },
      "&:hover": {
        ".menu-item-label": {
          color: `${themes[theme].menu.hover.color} !important`,
        },
        svg: {
          color: `${themes[theme].menu.hover.color} !important`,
        },
        backgroundColor: "transparent",
      },
    },
    label: ({ open }) => ({
      fontWeight: open ? 600 : undefined,
    }),
  };

  const sidebarMenus = useMemo(() => {
    return lists.filter((item) => item.isSidebar);
  }, [lists]);

  return (
    <Menu
      menuItemStyles={menuItemStyles}
      rootStyles={{ flex: "1 1 0%", overflow: "auto", width: "100%" }}
    >
      {sidebarMenus.map((item, idx) => {
        let currentLink = location.pathname.includes(
          item.includeRouteName ? item.includeRouteName : item.routeName
        );

        return (
          <Tooltip
            placement="right"
            title={
              <>
                <div>{item.name}</div>
                {item.disabled && (
                  <div style={{ color: "red", fontWeight: "bold" }}>
                    *Subscription required
                  </div>
                )}
              </>
            }
            key={idx}
            color={"#f0f0f0"}
            arrow={false}
            overlayInnerStyle={{
              fontSize: 10,
              minHeight: 0,
              color: COLORS.PRIMARY1,
              marginLeft: -20,
              marginBottom: 12,
            }}
            trigger="hover"
          >
            <div>
              <MenuItemComponent
                idx={idx}
                item={item}
                currentLink={currentLink}
              />
            </div>
          </Tooltip>
        );
      })}
    </Menu>
  );
}

export default MenuComponent;
